import { render, staticRenderFns } from "./BlockType23BigRow.vue?vue&type=template&id=49b4fb22&scoped=true"
import script from "./BlockType23BigRow.vue?vue&type=script&lang=ts"
export * from "./BlockType23BigRow.vue?vue&type=script&lang=ts"
import style0 from "./BlockType23BigRow.vue?vue&type=style&index=0&id=49b4fb22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b4fb22",
  null
  
)

export default component.exports